import React, { Component } from 'react';

import { localeStrings as strings } from 'applicationConfig';

import BaseOrderView from './BaseOrderView';

// Reusable function for className
const hideIfNoOrders = (row) => (!row.lOrders && !row.rOrders ? 'none-display' : '');

const GRID_COLUMNS = [
  {
    field: 'groupId',
    columnHeader: "",
    width: '0',
    hidden: true,
    groupField: true
  },
  {
    field: 'instrumentId',
    columnHeader: strings.dataViewing.tableHeaders.instrumentId,
    width: '10em',
    sortable: true,
    className: hideIfNoOrders
  },
  {
    field: 'lOrders',
    columnHeader: strings.dataViewing.tableHeaders.orders,
    width: '5.5em'
  },
  {
    field: 'bidPrice',
    columnHeader: strings.dataViewing.tableHeaders.bidPrice,
    width: '10em'
  },
  {
    field: 'aggrBidVol',
    columnHeader: strings.dataViewing.tableHeaders.aggrBidVol,
    width: '10em'
  },
  {
    field: 'marketMakerL',
    columnHeader: strings.dataViewing.tableHeaders.marketMaker,
    width: '7.8em',
    required: false,
    className: hideIfNoOrders
  },
  {
    field: 'tradingSystemL',
    columnHeader: strings.dataViewing.tableHeaders.tradingSystem,
    width: '4.5em',
    required: false,
    className: hideIfNoOrders
  },
  {
    field: 'tradingSystemPhaseL',
    columnHeader: strings.dataViewing.tableHeaders.tradingSystemPhase,
    width: '5em',
    required: false,
    className: hideIfNoOrders
  },
  {
    field: 'aggregatedQuotesAndOrderL',
    columnHeader: strings.dataViewing.tableHeaders.aggregatedQuotesAndOrder,
    width: '6em',
    required: false,
    className: hideIfNoOrders
  },
  {
    field: 'askPrice',
    columnHeader: strings.dataViewing.tableHeaders.askPrice,
    width: '10em',
    className: 'delimiter'
  },
  {
    field: 'aggrAskVol',
    columnHeader: strings.dataViewing.tableHeaders.aggrAskVol,
    width: '10em'
  },
  {
    field: 'marketMakerR',
    columnHeader: strings.dataViewing.tableHeaders.marketMaker,
    width: '7.8em',
    required: false,
    className: hideIfNoOrders
  },
  {
    field: 'tradingSystemR',
    columnHeader: strings.dataViewing.tableHeaders.tradingSystem,
    width: '4.5em',
    required: false,
    className: hideIfNoOrders
  },
  {
    field: 'tradingSystemPhaseR',
    columnHeader: strings.dataViewing.tableHeaders.tradingSystemPhase,
    width: '5em',
    required: false,
    className: hideIfNoOrders
  },
  {
    field: 'aggregatedQuotesAndOrderR',
    columnHeader: strings.dataViewing.tableHeaders.aggregatedQuotesAndOrder,
    width: '6em',
    required: false,
    className: hideIfNoOrders
  },
  {
    field: 'rOrders',
    columnHeader: strings.dataViewing.tableHeaders.orders,
    width: '5.5em'
  },

];

const GRID_COLUMNS_UK = [
  {
    field: 'groupId',
    columnHeader: "",
    width: '0',
    hidden: true,
    groupField: true
  },
  {
    field: 'instrumentId',
    columnHeader: strings.dataViewing.tableHeaders.instrumentId,
    width: '10em',
    sortable: true,
    className: hideIfNoOrders
  },
  {
    field: 'lOrders',
    columnHeader: strings.dataViewing.tableHeaders.orders,
    width: '5.5em'
  },
  {
    field: 'bidPrice',
    columnHeader: strings.dataViewing.tableHeaders.bidPrice,
    width: '10em'
  },
  {
    field: 'aggrBidVol',
    columnHeader: strings.dataViewing.tableHeaders.aggrBidVol,
    width: '10em'
  },
  {
    field: 'askPrice',
    columnHeader: strings.dataViewing.tableHeaders.askPrice,
    width: '10em',
    className: 'delimiter'
  },
  {
    field: 'aggrAskVol',
    columnHeader: strings.dataViewing.tableHeaders.aggrAskVol,
    width: '10em'
  },
  {
    field: 'rOrders',
    columnHeader: strings.dataViewing.tableHeaders.orders,
    width: '5.5em'
  },

];

class ClobOrderView extends Component {
  render() {
    const columns = this.props.order.venueLocation === 1 ? GRID_COLUMNS_UK : GRID_COLUMNS;

    return <BaseOrderView gridColumns={columns} showExpandCollapse={false} {...this.props} />;
  }
}

export default ClobOrderView;


// WEBPACK FOOTER //
// ./src/containers/DataViewing/orderViews/ClobOrderView.jsx